// extracted by mini-css-extract-plugin
export default {"link":"GameOnboardingInstructionOpenTicket_link__hMvAL"};